import { bunja } from 'bunja';

import { marketsAtom } from './internal/fixed-topics/market';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/market';

export const marketsBunja = bunja(() => {
  bunja.use(r230522SocketBunja);
  return { marketsAtom };
});
marketsBunja.debugLabel = 'marketsBunja';
